<template>
  <div class="flex flex-col w-full">
    <Toast position="top-[48px]"></Toast>
    <div class="text-[2rem] leading-[2.5rem] font-black text-[#433D31] tracking-[-0.03em]">
      Reset Password
    </div>
    <!-- TODO: implement here standalone first, to refactor to single component -->
    <div class="text-[#433D31] mt-[8px]">
      Please enter the 6-digit code sent to
      <span class="font-black text-[#0B0C0F] tracking-[-0.03em]">{{ email }}</span>
    </div>

    <div class="pt-[40px]">
      <div class="w-full flex justify-between mb-[16px]">
        <v-otp-input
          ref="otpInput"
          v-model:value="otpValue"
          input-classes="otp-input"
          input-type="number"
          inputmode="numeric"
          separator=" "
          :num-inputs="6"
          :should-auto-focus="true"
          :is-disabled="isLoading || loading"
          @on-complete="handleNext"
        />
      </div>

      <p v-if="hasError" class="text-[#EC4E20] text-[1rem] leading-[1.5rem] mt-[4px]">
        {{ errorMessage }}
      </p>
      <p
        class="text-[1rem] leading-[1.5rem] mt-[32px] mb-[36px] text-[#000000] text-center"
        v-if="!showResendButton"
      >
        Resend Code in {{ showResendButtonCount }} sec
      </p>

      <p
        class="text-[1rem] leading-[1.5rem] mt-[32px] mb-[36px] text-[#454BEF] text-center underline cursor-pointer"
        v-if="showResendButton"
        @click="resendOtp"
      >
        Resend Code
      </p>
    </div>
  </div>
</template>
<script>
import VOtpInput from 'vue3-otp-input';
import Toast from '@/components/common/Toast.vue';
import { mapState } from 'vuex';

export default {
  components: {
    Toast,
    VOtpInput,
  },
  props: ['email'],
  data() {
    return {
      showResendButton: false,
      showResendButtonCount: 60,
      otpTimer: null,
      otpValue: '',
      hasError: false,
      errorMessage: '',
      loading: false,
    };
  },
  computed: {
    ...mapState('forgotCredentials', ['isLoading']),
  },
  mounted() {
    this.startResendTimer();
  },
  beforeUnmount() {
    if (this.otpTimer) {
      clearInterval(this.otpTimer);
    }
  },
  methods: {
    startResendTimer() {
      this.showResendButton = false;
      this.showResendButtonCount = 60;

      this.otpTimer = setInterval(() => {
        this.showResendButtonCount--;
        if (this.showResendButtonCount === 0) {
          this.showResendButton = true;
          clearInterval(this.otpTimer);
        }
      }, 1000);
    },
    async resendOtp() {
      try {
        this.startResendTimer();
        await this.$store.dispatch('forgotCredentials/sendForgotPasswordOtp', this.email);
      } catch (error) {
        console.error(error);
      }
    },
    async handleNext() {
      if (this.loading) return;
      this.loading = true;
      this.hasError = false;
      try {
        await this.$store.dispatch('forgotCredentials/verifyForgotPasswordOtp', {
          email: this.email,
          otp: this.otpValue,
        });
        this.$emit('success');
      } catch (error) {
        this.$refs.otpInput.clearInput();
        // If its invalid input, show as error message below input
        if (error.response?.data?.message?.includes('Incorrect OTP')) {
          this.hasError = true;
          this.errorMessage = 'Wrong OTP entered, Please try again.';
        }
        console.error(error);
        this.otpValue = '';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
:deep(.otp-input) {
  width: 48px;
  height: 69px;
  border-radius: 12px;
  border: 1px solid #d8dadc;
  text-align: center;
  background: #f6f4f0;
  font-size: 18px;
  font-weight: 600;
}

:deep(.otp-input:focus) {
  border: 1.1px solid #454bef;
  outline: none;
}

:deep(.otp-input.error) {
  border-color: #ec4e20;
  background-color: #fef3f2;
}

:deep(.otp-input.error:focus) {
  border-color: #ec4e20;
  outline: none;
}

:deep(input::-webkit-outer-spin-button),
:deep(input::-webkit-inner-spin-button) {
  -webkit-appearance: none;
  margin: 0;
}

:deep(input[type='number']) {
  -moz-appearance: textfield;
}
</style>
